export default "__VITE_ASSET__UjaaR3FG__"